import { produce } from "immer";
import { select } from "redux-saga/effects";

import { fastClone } from "core/utils/clone";
import replayManager from "legacy/workers/replay/ApiDSLReplayManager";
import type { ApiDtoWithPb } from "store/slices/apisV2/slice";
import { EntitiesErrorType } from "store/utils/types";

import { createSaga, callSagas } from "../../../utils/saga";
import { selectV2ApiById } from "../selectors";
import slice from "../slice";
import { updateV2ApiSaga } from "./updateV2Api";

function* updateV2ApiTriggersInternal(payload: {
  runOnPageLoad: boolean | undefined;
  apiId: string;
}): Generator<unknown, void, any> {
  const { runOnPageLoad, apiId } = payload;

  const api: ReturnType<typeof selectV2ApiById> = yield select((state) =>
    selectV2ApiById(state, apiId),
  );

  if (api == null) {
    return;
  }
  const newApi: ApiDtoWithPb = produce(api, (draft) => {
    draft.apiPb.trigger.application ??= {};
    draft.apiPb.trigger.application.options ??= {};
    draft.apiPb.trigger.application.options.executeOnPageLoad = runOnPageLoad;
  });
  yield callSagas([updateV2ApiSaga.apply({ apiPb: newApi.apiPb })]);
}

export const updateV2ApiTrigger = createSaga(
  updateV2ApiTriggersInternal,
  "updateV2ApiTriggersSaga",
  {
    sliceName: slice.name,
  },
);

slice.saga(updateV2ApiTrigger, {
  start(state, { payload }) {
    delete state.errors[payload.apiId];
    // add the initial api dsl to the replay state if not already there
    const apiId = payload.apiId;
    replayManager.initializeManager(
      apiId,
      fastClone(state.entities[apiId]?.apiPb),
    );
  },
  success(state, { payload, meta }) {
    // update the replay manager
    if (meta?.args?.apiId) {
      const apiId = meta.args.apiId;
      replayManager.update(apiId, fastClone(state.entities[apiId]?.apiPb));
    }
  },
  error(state, { payload, meta }) {
    state.errors[meta.args.apiId] = {
      type: EntitiesErrorType.SAVE_ERROR,
      error: payload,
    };
  },
});
